module.exports = __webpack_public_path__ + "static/MoneyBagImage-cafd5e2f920d8f7932bf6bdf6e5b4098.png";